import { IHousePhoto, ISelectItems } from "../interfaces/intarfaces";
import { countryData } from "../assets/data/isoNameCountries";
import { COUNTRIES } from "assets/data/countries_provinces_cities";
import { Languages, TLang } from "assets/data/isoNameLanguage";

export const getCountries = (lang: TLang = "GB"): ISelectItems[] => {
  function sortItemsLocale<T extends ISelectItems>(a: T, b: T): number {
    if (!a.hasOwnProperty("label") || a.label === undefined) return 0;
    let aLabel = a.label.toLowerCase(),
      bLabel = b.label.toLowerCase();
    return aLabel.localeCompare(bLabel, lang);
  }
  return [
    ...countryData.map((item) => ({
      value: item["code"],
      label: item.name[lang]
    }))
  ].sort(sortItemsLocale);
};
// export const getCountries = (lang: TLang = "GB"): ISelectItems[] =>
//   countryData.map((item) => (
//     { value: item["code"], label: item.name[lang] })).sort(sortItems);;

// export const getCountries = (): ISelectItems[] => {
//   return countryData.map((item) => ({
//     value: item["code"],
//     label: item["name"],
//   }));
// };

export const sortArray = <T extends IHousePhoto>(a: T, b: T) => {
  if (!a.hasOwnProperty("timestamp")) return 0;
  let aLabel = a.timestamp.toLowerCase(),
    bLabel = b.timestamp.toLowerCase();
  if (aLabel < bLabel) return -1;
  if (aLabel > bLabel) return 1;
  return 0;
};

export const sortItems = <T extends { label: string }>(a: T, b: T) => {
  if (!a.hasOwnProperty("label") || a.label === undefined) return 0;
  let aLabel = a.label.toLowerCase(),
    bLabel = b.label.toLowerCase();
  if (aLabel < bLabel) return -1;
  if (aLabel > bLabel) return 1;
  return 0;
};

export const sortTop = (
  items: ISelectItems[],
  topVal: string[] | undefined
): ISelectItems[] => {
  if (topVal === undefined || !!!topVal.length) return items;

  const newArray: ISelectItems[] = items.filter((item) =>
    topVal
      .map((item) => item.toLocaleUpperCase())
      .includes(item.value as string)
  );
  return newArray.concat(
    items.filter(
      (item) =>
        !topVal
          .map((item) => item.toLocaleUpperCase())
          .includes(item.value as string)
    )
  );
};

export const getNameCountry = (x: string, lang: TLang = "GB") => {
  const country = getCountries(lang).filter((item) => item.value === x);
  return country.length ? country[0].label : "";
};

export const getPhoneCodes = (): ISelectItems[] => {
  const temp: string[] = [];
  return countryData
    .map((item) => ({
      value: item["dial_code"],
      label: String(item["dial_code"])
    }))
    .filter((x) => {
      if (temp.includes(x.label) || !x.label) return false;
      temp.push(x.label);
      return true;
    })
    .sort(sortItems);
};

export const getCountryPhoneCode = (
  country: string,
  lang: TLang = "GB"
): ISelectItems => {
  return countryData
    .filter((item) =>
      country.length === 2 ? item.code === country : item.name[lang] === country
    )
    .map((item) => ({
      value: item["dial_code"],
      label: String(item["dial_code"])
    }))[0];
};

export const getDegree = (): ISelectItems[] => [
  { value: "bach", label: "Bachelavr" },
  { value: "master", label: "Master" }
];

export const getLanguage = (lang: TLang = "GB"): ISelectItems[] =>
  Languages.map((item) => ({ value: item.value, label: item.label[lang] }));

export const arrayLanguages = (keys: string[], lang: TLang = "GB"): string[] =>
  getLanguage(lang)
    .filter((item) => keys.includes(item.value as string))
    .map((item) => item.label);

export const getCities = (
  province: string | undefined,
  country: string = "Netherlands",
  lang: TLang = "GB"
) => {
  const countryName = country.length === 2 ? getNameCountry(country) : country;
  return !province
    ? getAllCities(country)
    : COUNTRIES[countryName][province]
        .map((item) => ({ value: item, label: item }))
        .sort(sortItems);
};

export const getAllProvinces = (country: string | undefined) => {
  return country
    ? Object.keys(COUNTRIES[getNameCountry(country)])
        .map((item) => ({ value: item, label: item }))
        .sort(sortItems)
    : [];
};

export const getCountriesCities = (country: string | undefined) => {
  if (!country) return [];
  const countryName = country.length === 2 ? getNameCountry(country) : country;
  return Object.keys(COUNTRIES[countryName])
    .map((cityKey: string) => COUNTRIES[countryName][cityKey])
    .flatMap((items) => items);
};

export const getAllCities = (country: string = "NL"): ISelectItems[] =>
  getCountriesCities(getNameCountry(country))
    .map((item) => ({ value: item, label: item } as ISelectItems))
    .sort(sortItems);

export const getProvince = (
  city: string,
  country: string = "Netherlands"
): string => {
  for (let province of Object.keys(COUNTRIES[country])) {
    if (COUNTRIES[country][province].includes(city)) return province;
  }
  return "";
};
